import { useEffect } from 'react';

export const useKeyboard = (keyMap) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      // 防止在输入框中触发快捷键
      if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') {
        return;
      }

      const key = event.code;
      
      if (keyMap[key]) {
        keyMap[key](event);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [keyMap]);
};

// 预定义的快捷键映射
export const DEFAULT_SHORTCUTS = {
  // 播放控制
  'Space': '播放/暂停',
  'ArrowLeft': '上一帧',
  'ArrowRight': '下一帧',
  
  // 剪辑功能
  'KeyO': '进攻片段',
  'KeyD': '防守片段',
  
  // 编辑功能
  'KeyZ': '撤销 (Ctrl+Z)',
  'KeyY': '重做 (Ctrl+Y)',
  'KeyE': '导出 (Ctrl+E)',
  
  // 数字键 - 倍速控制
  'Digit1': '1倍速',
  'Digit2': '2倍速',
  'Digit4': '4倍速',
  'Digit8': '8倍速'
};

// 检查修饰键的辅助函数
export const hasModifier = (event, modifier) => {
  switch (modifier) {
    case 'ctrl':
      return event.ctrlKey || event.metaKey; // Mac 上使用 Cmd 键
    case 'shift':
      return event.shiftKey;
    case 'alt':
      return event.altKey;
    default:
      return false;
  }
};

// 组合键处理
export const useKeyboardWithModifiers = (keyMap) => {
  useEffect(() => {
    const handleKeyDown = (event) => {
      // 防止在输入框中触发快捷键
      if (event.target.tagName === 'INPUT' || event.target.tagName === 'TEXTAREA') {
        return;
      }

      const key = event.code;
      const ctrl = event.ctrlKey || event.metaKey;
      const shift = event.shiftKey;
      const alt = event.altKey;
      
      // 构建键组合字符串
      let keyCombo = '';
      if (ctrl) keyCombo += 'Ctrl+';
      if (shift) keyCombo += 'Shift+';
      if (alt) keyCombo += 'Alt+';
      keyCombo += key;
      
      // 先检查组合键
      if (keyMap[keyCombo]) {
        keyMap[keyCombo](event);
      } else if (keyMap[key] && !ctrl && !shift && !alt) {
        // 如果没有修饰键，检查单独的键
        keyMap[key](event);
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [keyMap]);
};